import React, { useState, useEffect } from "react";
import { Button, notification, Tooltip, Form } from "antd";
import style from "../../index.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import { GoldOutlined } from "@ant-design/icons";
import ModalCUIngredient from "features/sushi/components/ModalCUIngredient";
import ingredientApi from "api/ingredient";
import TableIngredient from "features/sushi/components/TableIngredient";
import FormFilter from "features/sushi/components/FormFilter";
import { ingredientOptions } from "constants/index";

const cx = classNames.bind(style);

export default function IngredientPage() {
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();

  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation()

  const [openModalCU, setOpenModalCU] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);


  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const onOpenModalCU = (item) => {
    item && setSelected(item)
    setOpenModalCU(true)
  }

  const onCloseModalCU = () => {
    setOpenModalCU(false)
    setSelected(null)
    form.resetFields();
  }

  const fetchIngredient = async () => {
    try {
      setLoading(true)
      const res = await ingredientApi.getAllIngredient({ 
        name: formSearch.getFieldValue('name'),
        ...(formSearch.getFieldValue('type') && { type: formSearch.getFieldValue('type') })
      });
      setData(res.ingredient || [])
    } catch (error) {
      console.log("🚀 ~ error:", 123)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchIngredient()
  }, [])


  const onSubmitCU = async (values) => {
    try {
      setLoading(true)
      if (selected) {
        const res = await ingredientApi.updateIngredient(selected._id, values);
        if (res?.success) {
          openNotificationWithIcon("success", t('notification'), t('success'));
          onCloseModalCU();
          fetchIngredient()
        }
      } else {
        const res = await ingredientApi.createIngredient(values);
        if (res?.success) {
          openNotificationWithIcon("success", t('notification'), t('success'));
          onCloseModalCU();
          fetchIngredient()
        }
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={cx("page-sushi")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t('ingredientSushi')}</p>
        <Button onClick={() => onOpenModalCU()}>
          <Tooltip title={t("addIngredient")}>
            <GoldOutlined />
          </Tooltip>
        </Button>
      </div>
      <FormFilter loading={loading} form={formSearch} submit={fetchIngredient} options={ingredientOptions} /> 
      <TableIngredient loading={loading} dataSource={data} onOpenModalUpdate={onOpenModalCU} />
      <ModalCUIngredient
        form={form}
        openModal={openModalCU}
        onCloseModal={onCloseModalCU}
        selected={selected}
        onSubmit={onSubmitCU}
      />
    </div>
  );
}
